import React from 'react'

import styles from './styles.module.scss'

const MagentaStar: React.FC = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.magentaStar}
        >
            <path
                d="M9.23915 1.34164C9.47864 0.604593 10.5214 0.604592 10.7608 1.34164L12.5146 6.73901C12.6217 7.06863 12.9288 7.2918 13.2754 7.2918H18.9505C19.7255 7.2918 20.0477 8.28349 19.4208 8.73901L14.8295 12.0748C14.5491 12.2785 14.4318 12.6396 14.5389 12.9692L16.2926 18.3666C16.5321 19.1036 15.6885 19.7165 15.0615 19.261L10.4702 15.9252C10.1898 15.7215 9.81016 15.7215 9.52977 15.9252L4.9385 19.261C4.31153 19.7165 3.46794 19.1036 3.70742 18.3666L5.46113 12.9692C5.56823 12.6396 5.45091 12.2785 5.17052 12.0748L0.579241 8.73901C-0.0477297 8.28349 0.27449 7.2918 1.04947 7.2918H6.7246C7.07118 7.2918 7.37834 7.06863 7.48544 6.73901L9.23915 1.34164Z"
                fill="#CE3197"
            />
        </svg>
    )
}

export default MagentaStar
